import React from 'react';

import BaseSessionNav from 'components/BaseSessionNav';
import PropTypes from 'prop-types';
import { connect } from 'omni-common-ui';
import { actions as UiState } from 'data/UiState';
import { accessors as writingAssignment } from 'data/WritingAssignment';

class WritingAssignmentSessionNav extends BaseSessionNav {
  _hasNext() {
    return this.props.hasNext;
  }

  _hasPrevious() {
    return this.props.hasPrevious;
  }

  _hasNextUnit() {
    return false;
  }

  _hasPreviousUnit() {
    return false;
  }

  _getNextUnitText() {
    return null;
  }

  _getPreviousUnitText() {
    return null;
  }

  _getHeadingText() {
    return `Unit ${this.props.currentLesson.unitNo}`;
  }

  _getAdditionalChildren() {
    return <h2>
      Lesson {this.props.currentLesson.lessonNo}
    </h2>;
  }

  render() {
    if (this.props.currentLesson) {
      return super.render();
    }
    return null;
  }
}

WritingAssignmentSessionNav.propTypes = Object.assign({
  currentLesson: PropTypes.object,
  hasNext: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  previousSessionLinkHref: PropTypes.string,
  nextSessionLinkHref: PropTypes.string,
  isHide: PropTypes.boolean,
}, BaseSessionNav.propTypes);

function mapStateToProps(state, ownProps) {
  const { groupId, lessonSeq } = ownProps.params;
  const sessions = writingAssignment.getCoreWritingAssignmentLessons(state, groupId);
  if (sessions) {
    const currentLesson = sessions.find((s) => `${s.seq}` === `${lessonSeq}`);
    const hasNext = Number(lessonSeq) < sessions.size - 1;
    const hasPrevious = Number(lessonSeq) > 0;
    return {
      currentLesson,
      hasNext,
      hasPrevious,
      previousSessionLinkHref: ownProps.buildRoute({
        lessonSeq: Number(lessonSeq) - 1,
      }),
      nextSessionLinkHref: ownProps.buildRoute({
        lessonSeq: Number(lessonSeq) + 1,
      }),
      isHide: ! UiState.getShowNavigationBar(state),
    };
  }
}

export default connect(mapStateToProps, null)(WritingAssignmentSessionNav);



// WEBPACK FOOTER //
// ./components/WritingAssignmentSessionNav/index.jsx